import MuiTimelineItem, { TimelineItemProps as MuiProps } from '@material-ui/lab/TimelineItem';
import React, { FunctionComponent } from 'react';
import useStyles from './style';

export interface TimelineItemProps extends MuiProps {
    /**
     * The content of the component.
     */
    children?: React.ReactNode;
    /**
     * Styles applied to the root element if no there isn't TimelineOppositeContent
     */
    hasOppositeContent?: true | false;
}

const TimelineItem: FunctionComponent<TimelineItemProps> = ({ hasOppositeContent, ...props }: TimelineItemProps) => {
    const classes = useStyles({ hasOppositeContent });
    return <MuiTimelineItem classes={classes} {...props} />;
};

export default TimelineItem;
